import { render, staticRenderFns } from "./AdminSidebarContainer.vue?vue&type=template&id=1ea500aa&"
import script from "./AdminSidebarContainer.vue?vue&type=script&lang=js&"
export * from "./AdminSidebarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports